import Button from '@creditflowresearch/uilib/Button';
import Flex from '@creditflowresearch/uilib/Flex';
import { PanelLink } from '@creditflowresearch/uilib/PanelControl';
import ToolLinkItem from '@/creditflowresearch/ui/common/components/molecules/ToolLinkItem';
import { IPanelTools } from '@/creditflowresearch/domain/vo/ITools';

import styles from './panelTools.module.scss';

const PanelTools = ({
  title = 'Tools (ABS)',
  topOptions = [],
  toolsOptions = [],
}: IPanelTools) => (
  <>
    <Flex gap={ 10 } direction="column" className={ styles.topOptions }>
      { topOptions.map((option) => (
        <Button
          key={ option.link }
          as={ PanelLink }
          to={ option.link }
          dataTest="toolWrapper"
          variant="outline"
          size="S"
          fit="full"
          className={ styles.topOptionLink }
        >
          { option.text }
        </Button>
      )) }
    </Flex>
    <div className={ styles.title }>{ title }</div>
    { toolsOptions.map((tool) => <ToolLinkItem key={ tool.link } { ...tool } />) }
  </>
);

export default PanelTools;
